// Module
var code = `<div class="order-panel-base{{^.isAllowPadding}} _no-padding{{/}}">
    <div class="order-panel-base-container-btn" {{^.visibleContainerBtn}} style="display: none;" {{/}}>
        <tradingButtonStripe name='btns' />
    </div>

    <div class="order-panel-base-container-table">
        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;